import { render, staticRenderFns } from "./PechatLogo.vue?vue&type=template&id=6f1aeb12&scoped=true"
var script = {}
import style0 from "./PechatLogo.vue?vue&type=style&index=0&id=6f1aeb12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1aeb12",
  null
  
)

export default component.exports